module.exports = __webpack_public_path__ + "static/media/VEL.70b26454.png";